import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from '../../../services/main.service';

@Component({
  selector: 'app-value-detail',
  templateUrl: './value-detail.component.html',
  styleUrls: ['./value-detail.component.scss']
})
export class ValueDetailComponent implements OnInit {

  currentValue;
  values;
  backgroundImageSrc;

  constructor( private activatedRoute: ActivatedRoute,
               private router: Router,
               public mainService: MainService ) {
    this.values = [{
      id: 'teaming',
      imageUrl: 'assets/icons/teaming.svg',
      imageInfosUrl: 'assets/icons/infos/teaming.svg',
      title: 'values.teaming.title',
      description: 'values.teaming.description',
      quote: {
        image: 'assets/images/values/african_proverb.png',
        content: 'values.teaming.quote',
        author: 'values.teaming.author' }
    },
    {
      id: 'growing',
      imageUrl: 'assets/icons/growing.svg',
      imageInfosUrl: 'assets/icons/infos/growing.svg',
      title: 'values.growing.title',
      description: 'values.growing.description',
      quote: {
        image: 'assets/images/values/yoko_ono.jpg',
        content: 'values.growing.quote',
        author: 'values.growing.author' }
    },
    {
      id: 'innovation',
      imageUrl: 'assets/icons/innovation.svg',
      imageInfosUrl: 'assets/icons/infos/innovation.svg',
      title: 'values.innovation.title',
      description: 'values.innovation.description',
      quote: {
        image: 'assets/images/values/steve_jobs.jpg',
        content: 'values.innovation.quote',
        author: 'values.innovation.author' },
    },
    {
      id: 'courage',
      imageUrl: 'assets/icons/courage.svg',
      imageInfosUrl: 'assets/icons/infos/courage.svg',
      title: 'values.courage.title',
      description: 'values.courage.description',
      quote: {
        image: 'assets/images/values/nelson_mandela.jpg',
        content: 'values.courage.quote',
        author: 'values.courage.author' }
    }];

    this.activatedRoute.params.subscribe(
      params => {
        this.currentValue = this.values.find(function (element) {
          return element.id === params.valueid;
        });
      }
    );
  }

  ngOnInit() { }

  public goBack() {
    this.router.navigate(['/home', {outlets: {values: ['values'] }}]);
    // window.scrollTo(0, document.getElementById('value-detail').offsetTop);
  }

}
